import { Component, Input, OnInit } from '@angular/core';

export interface InformacionComponente {
  titulo: string;
  subtitulo: string;
  imagen?: string;
  descripcion?: string;
  nombreAccion?: string;
  accion?: string;
}
@Component({
  selector: 'zona-ayuda-venta',
  templateUrl: './ayuda-venta.component.html',
  styleUrls: ['./ayuda-venta.component.scss']
})
export class AyudaVentaComponent implements OnInit {

  @Input() informacionComponente: InformacionComponente;

  constructor() { }

  ngOnInit(): void {
  }

}
